import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

manager.register('ajax-filter', (component, elements, attributes, properties) => {
	const {
		filter,
		loader,
		container
	} = elements;

	const {
		getDataUrl,
	} = properties;

	let xhr = null;

	// Construct URLSearchParams object instance from current URL querystring.
	const queryParams = new URLSearchParams(window.location.search);

	$(filter).dropdown({
		clearable: true,
		onChange: update
	});

	const value = $(filter).dropdown('get value');
	update(value);

	function update(value) {
		if (getDataUrl) {

			if (loader) {
				$(loader).stop().show();
			}

			if (container) {
				container.innerHTML = '';
			}

			if (xhr) {
				xhr.abort();
			}

			xhr = manager.get(`${getDataUrl}/${value}`, (response) => {
				// Set new or modify existing parameter value.
				queryParams.set("filter", value);

				// Replace current querystring with the new one.

				history.replaceState(null, null, value ? "?" + queryParams.toString() : '?');

				if (container) {
					container.innerHTML = response;
					$(container).stop().fadeIn();
				}

				manager.execute(container);

				if (loader) {
					$(loader).stop().hide();
				}
			});
		}
	}
});